import { createSortOption } from "@nosto/preact"
export const sizes = [24, 48, 72]

export const sortOptions = [
    createSortOption("score", "Most relevant", { field: "score", order: "desc" }),
    createSortOption("date", "Newest", { field: "datePublished", order: "desc" }),
    createSortOption("name", "Name: A - Z", { field: "name", order: "asc" }),
    createSortOption("-name", "Name: Z - A", { field: "name", order: "desc" }),
    createSortOption("price", "Price: Low to High", { field: "price", order: "asc" }),
    createSortOption("-price", "Price: High to Low", { field: "price", order: "desc" }),
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 6,
    autocompleteKeywordsSize: 5,
    historySize: 5
}